@import 'src/styles/fonts';
@import 'src/styles/palette';

.agreements {
  h2 {
    @include merriweather(20);
  }

  h3 {
    @include barlow(16);
  }

  .practiceplace {
    display: inline-flex;
  }

  .arrowIcon {
    position: absolute;
    background-color: inherit;
    border: none;
    left: -3em;
  }

  .endNodeIcon {
    position: absolute;
    top: 0.2em;
    left: -1.75em;
  }

  .practiceplaceName {
    position: relative;
  }

  .sigmaIcon {
    margin-right: 0.25em;
  }

  .practiceplaceNameStrong {
    font-weight: 600;
  }

  .practiceplaceNameCell {
    width: 35%;
  }

  .avtaleCell {
    width: 15%;

    .avtaleCellWrapper {
      display: flex;
      align-items: center;
      gap: 0.5em;
    }
  }

  .statusCell {
    width: 20%;
  }

  .bestillingCell {
    width: 10%;
  }

  .kapasitetCell {
    width: 10%;
  }

  .actionCell {
    width: 10%;
  }
}

.buttonContainer {
  display: flex;
  float: right;
  padding-top: 16px;

  button {
    margin-left: 15px;
    margin-top: 5px;
  }
}

.tableMaxScroll {
  max-height: 90vh;
  overflow-y: auto;
}

.confirmationDialogList {
  font-weight: 600;
  margin: 1em 0;
}

.errorPracticePlaceCell {
  width: 45%;

  .errorPracticePlaceWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .errorPracticePlace {
      flex: 1;
      display: inline-flex;
    }

    .prefixAndPracticeplace {
      display: inline;

      .errorPracticePlaceBestilling {
        display: inline;

        & ~ .practiceplaceName {
          display: inline;
        }
      }
    }

    .kapasitetBestilling {
      margin-right: 0.5em;
    }
  }
}

.errorAgreementCell {
  width: 10%;
}

.errorStatusCell {
  width: 25%;

  .errorStatusCellWrapper {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }
}

.errorActionCell {
  width: 10%;
}

.errorConfirmBtnContainer {
  margin-top: 1em;
  display: flex;
  justify-content: flex-end;
}

.modalContentHeader {
  @include barlow(18, 600);
  color: _palette(secondary);
  margin-top: 0;
}

.errorForDeletion {
  @include barlow(16);
  width: 100%;

  .errorForDeletionType {
    text-transform: capitalize;

    &::before {
      content: ' ⇒ ';
    }
  }
}
